var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles, Card } from '@material-ui/core/';
import React from 'react';
export var useStyles = makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(2),
        border: 'thin solid #e9eaed',
        maxHeight: '90px'
    },
    label: {
        fontSize: '14px'
    },
    metric: {
        fontSize: '24px'
    },
    metricWrapper: {
        marginBottom: '8px'
    },
    labelWrapper: {},
    inlineSkeleton: {
        display: 'inline-block'
    },
    warningMode: {
        backgroundColor: '#EF7E7E'
    }
}); });
export function MetricCardBase(_a) {
    var metric = _a.metric, label = _a.label, _b = _a.elevation, elevation = _b === void 0 ? 0 : _b, _c = _a.warningMode, warningMode = _c === void 0 ? false : _c, cardProps = __rest(_a, ["metric", "label", "elevation", "warningMode"]);
    var classes = useStyles();
    var rootClasses = [classes.root];
    if (warningMode) {
        rootClasses.push(classes.warningMode);
    }
    return (React.createElement(Card, __assign({ className: rootClasses.join(' '), elevation: elevation }, cardProps),
        React.createElement("div", { className: classes.metricWrapper }, metric),
        React.createElement("div", { className: classes.labelWrapper }, label)));
}
//# sourceMappingURL=MetricCard.js.map